<ngx-extended-pdf-viewer [src]="fileUrl" height="95vh"
[showToolbar]="true"
  [showSidebarButton]="false"
  [showFindButton]="false"
  [showPagingButtons]="true"
  [showSignatureEditor]="false"
  [showHighlightEditor]="false"
  [showDrawEditor]="false"
  [showCommentEditor]="false"
  [showStampEditor]="false"
  [showTextEditor]="false"
  [showZoomButtons]="true"
  [showPresentationModeButton]="false"
  [showOpenFileButton]="false"
  [showPrintButton]="false"
  [showDownloadButton]="true"
  [showSecondaryToolbarButton]="true"
  [showMovePageButton]="false"
  [showRotateCwButton]="false"
  [showRotateCcwButton]="false"
  [showHandToolButton]="false"
  [showScrollingButtons]="false"
  [showSpreadButton]="false"
  [showPropertiesButton]="false"
  [handTool]="false"
  [textLayer]="true"
  [zoom]="'page-width'"
  [filenameForDownload]="fileName"
  >
</ngx-extended-pdf-viewer>
